import api from "./api";

class FornitoriManager {

    fornitoriAutocomplete(config?: any) {
        return api.get(`/fornitori`, config)
    }

    fornitoriUpdate(fornitore_id: string | number, data: any) {
        return api.put(`fornitori/${fornitore_id}`, data)
    }

    fornitoreCreate(data: any) {
        return api.post(`fornitori/`, data)
    }

    listaFornitori(config?: any) {
        return api.get(`/fornitori`, config)
    }

    exportFornitori(config?: any) {
        return api.get(`/fornitori/download/`, config)
    }

    fornitore(id: number | string) {
        return api.get(`/fornitori/${id}`)
    }

    approvazione(cliente_id: number | string | undefined, approvato:boolean) {
        return api.post(`/fornitori/${cliente_id}/approvazione`, {approvato: approvato})
    }

    settori(fornitore_id: number | string) {
        return api.get(`/fornitori/${fornitore_id}/settori/`)
    }

    audits(fornitore_id: number | string) {
        return api.get(`/fornitori/${fornitore_id}/audits/`)
    }

    export(config?: any) {
        return api.get(`/fornitori/export`, config);
    }

    list = this.fornitoriAutocomplete
    retrieve = this.fornitore
    paginatedList = this.listaFornitori
}

const fornitoriManager = new FornitoriManager()

export default fornitoriManager
